import { render, staticRenderFns } from "./TechnicalError.vue?vue&type=template&id=7305bac6&scoped=true&lang=pug&"
import script from "./TechnicalError.vue?vue&type=script&setup=true&lang=js&"
export * from "./TechnicalError.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TechnicalError.scss?vue&type=style&index=0&id=7305bac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7305bac6",
  null
  
)

export default component.exports